(function () {
    'use strict';

    // overrides library factory to fix datepicker popup position.

    angular.module('pickadate')
        .factory('pickadateModalBindings', ['$window', '$document', function ($window, $document) {

            var computeStyles = function (element) {
                var topOffset = element.getAttribute('top-offset');

                return { top: (topOffset ? topOffset : element.offsetParent.offsetHeight) + 'px' };
            };

            var isDescendant = function (parent, child) {
                var node = child.parentNode;
                while (node !== null) {
                    if (node === parent) return true;
                    node = node.parentNode;
                }
                return false;
            };

            return function (scope, element, rootNode) {
                var togglePicker = function (toggle) {
                    scope.displayPicker = toggle;
                    scope.$apply();
                };

                element.on('focus', function () {
                    scope.modalStyles = computeStyles(element[0]);
                    togglePicker(true);
                });

                element.on('keydown', function (e) {
                    if (indexOf.call([9, 13, 27], e.keyCode) >= 0) togglePicker(false);
                });

                $document.on('click', function (e) {
                    if (isDescendant(rootNode, e.target) || e.target === element[0]) return;
                    togglePicker(false);
                });
            };

        }]);

})();
